module.exports = __webpack_public_path__ + "fonts/ToyotaType-Regular.09232a1.woff2";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/ToyotaType-Regular.woff2
// module id = rC1h
// module chunks = 13